const btn = document.querySelector('.mobile-nav-btn')
const menu = document.querySelector('.mobile-nav')

btn.addEventListener('click' , (e)=> {
  menu.classList.toggle('active')
  btn.classList.toggle('active')
}) 